import { useEffect, useRef, useState } from "react";
import { site } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";
import {
  instaImage1,
  instaImage2,
  instaImage3,
  instaImage4,
  instaImage5,
  instaImage6,
} from "@/mocks/images";

// ---------------------------------------------------------------------------
// INSTAGRAM FEED — Dra. Sâmia Albuquerque
// ---------------------------------------------------------------------------
// Para integração com a API real do Instagram, substitua o array postsMock
// abaixo pela resposta da API (ex: fetch do Instagram Basic Display API).
// Token de acesso: adicione em um Edge Function (Supabase) ou variável de
// ambiente segura. Nunca exponha tokens diretamente no frontend.
// ---------------------------------------------------------------------------

const postsMock = [
  {
    id: "1",
    imageUrl: instaImage1,
    postUrl: "https://www.instagram.com/p/DPe3SeJAAGC/",
    alt: "Conteúdo sobre cuidados com a pele no Instagram da Dra. Sâmia Albuquerque",
  },
  {
    id: "2",
    imageUrl: instaImage2,
    postUrl: "https://www.instagram.com/p/DPWbTD3jd0w/?img_index=1",
    alt: "Rotina profissional e ambiente do consultório da Dra. Sâmia Albuquerque",
  },
  {
    id: "3",
    imageUrl: instaImage3,
    postUrl: "https://www.instagram.com/p/DZAud6zgney/",
    alt: "Orientações de medicina estética por Dra. Sâmia Albuquerque",
  },
  {
    id: "4",
    imageUrl: instaImage4,
    postUrl: "https://www.instagram.com/p/DYAAL2oAP0F/",
    alt: "Novidades e tecnologias em tratamentos estéticos em Fortaleza",
  },
  {
    id: "5",
    imageUrl: instaImage5,
    postUrl: `${site.instagramUrl}/p/post5`,
    alt: "Dicas de skincare e bem-estar pela Dra. Sâmia Albuquerque",
  },
  {
    id: "6",
    imageUrl: instaImage6,
    postUrl: `${site.instagramUrl}/p/post6`,
    alt: "Resultados e transformações com medicina estética individualizada",
  },
];

export default function Instagram() {
  const [visibleCount, setVisibleCount] = useState(6);
  const gridRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const update = () => setVisibleCount(mq.matches ? 6 : 4);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  const displayedPosts = postsMock.slice(0, visibleCount);

  return (
    <section id="instagram" className="bg-background-100/80 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                Redes sociais
              </p>
              <h2 className="mt-3 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
                Acompanhe no Instagram
              </h2>
              <p className="mt-3 max-w-lg text-base leading-relaxed text-foreground-400">
                Conheça conteúdos, rotina profissional, orientações e novidades sobre medicina estética e cuidado individualizado.
              </p>
              <a
                href={site.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-accent-400 transition-colors hover:text-accent-300"
              >
                <i className="ri-instagram-line text-lg" />
                <span>{site.instagramHandle}</span>
              </a>
            </div>

            <a
              href={site.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-accent-500 px-6 py-3 text-sm font-semibold text-accent-400 transition-colors duration-300 hover:bg-accent-500 hover:text-background-50"
            >
              <i className="ri-instagram-line text-base" />
              Seguir no Instagram
            </a>
          </div>
        </Reveal>

        <div ref={gridRef} className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4">
          {displayedPosts.map((post, i) => (
            <Reveal key={post.id} delay={i * 80}>
              <a
                href={post.postUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square overflow-hidden rounded-lg bg-background-200"
                aria-label={`Ver publicação no Instagram: ${post.alt}`}
              >
                <img
                  src={post.imageUrl}
                  alt={post.alt}
                  title={post.alt}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-background-50/0 transition-colors duration-300 group-hover:bg-background-50/20" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/90 text-foreground-50 backdrop-blur-sm">
                    <i className="ri-instagram-line text-lg" />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="mt-10 flex items-center justify-center">
            <a
              href={site.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold text-accent-400 transition-colors hover:text-accent-300"
            >
              Veja mais conteúdos no Instagram
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}